export default {
    small: {
        name: 'small',
        size: '0.6rem',
    },
    medium: {
        name: 'medium',
        size: '0.7rem',
    },
    default: {
        name: 'default',
        size: '1rem', // will be used if nothing is specified
    },
    large: {
        name: 'large',
        size: '1.3rem',
    },
    massive: {
        name: 'massive',
        size: '1.8rem',
    },
    enormous: {
        name: 'enormous',
        size: '2rem',
    },
};
